import { useState, useContext, useEffect } from 'react'; // Adicione useEffect
import { useMediaQuery } from '@mui/material';
import './Chat.css';
import Historico from '../Historico';
import UnifiedChat from '../UnifiedChat/UnifiedChat';
import ActivityPanel from '../../components/ActivityPanel';
import { idDaMensagem } from '../UnifiedChat/helpers';
import ErrorBoundary from '../../components/ErrorBoundary';
import Links from '../Links';
import AddArquivo from './DatabaseUptdate';
import { useTranslation } from 'react-i18next';
import { AuthContext } from '../../authContext';
import NovidadesPopup from './NovidadesPopup'; // 1. Importe o novo componente
import { getDefaultChatModel } from '../../utils/assistantModels';

function Chat({ chatHistory, setChatHistory, loading, setLoading, sessions, setSessions, selectedSession, setSelectedSession, summaryInfo, setSummaryInfo, totalCost, setTotalCost, sessionId, setSessionId, user, assistant, assistantId }) {

  const isReportMode = false;
  const [expandedComponent, setExpandedComponent] = useState(null);
  const { t: tChat } = useTranslation('chat');
  const defaultChatModel = getDefaultChatModel(assistantId);
  const [modelByAssistant, setModelByAssistant] = useState({});
  const selectedModel = modelByAssistant[assistantId] ?? defaultChatModel;
  const setSelectedModel = (model) => {
    setModelByAssistant(prev => ({ ...prev, [assistantId]: model }));
  };
  const [messageSent, setMessageSent] = useState(false);

  // Tarefa 3.4: sinal usado pelo botao "Criar com Iris" do modal "Gerenciador
  // de Skills" (renderizado dentro de Historico) para disparar, no UnifiedChat
  // irmao, o mesmo fluxo de insercao do "/skill-creator" da Tarefa 1.1 - os
  // dois componentes nao tem acesso direto um ao outro, so ao pai em comum.
  const [createSkillSignal, setCreateSkillSignal] = useState(0);

  // Tarefa 5.1: sinal usado ao clicar num SkillCard do modal "Gerenciador de
  // Skills" (renderizado dentro de Historico) para disparar, no UnifiedChat
  // irmao, a insercao de "/nome-da-skill" no campo de mensagem (mesmo padrao
  // de handleSelectSkill, Tarefa 2.2) - mesmo mecanismo de sinal por pai comum
  // ja usado por createSkillSignal, mas carregando qual skill foi escolhida;
  // "seq" garante uma mudanca de referencia mesmo se a mesma skill for
  // escolhida de novo em sequencia.
  const [selectSkillRequest, setSelectSkillRequest] = useState(null);

  // Tarefa 6.4: mesmo mecanismo de sinal { skill, seq } de selectSkillRequest,
  // usado pelo item "Editar skill no chat" do menu de opcoes da tela "Detalhe
  // da Skill" (renderizada dentro do SkillsManagerModal, dentro de Historico)
  // - dispara, no UnifiedChat irmao, a insercao de "/nome-da-skill" + o texto
  // de ajuda de edicao (em vez do de "Experimentar no chat", que reaproveita
  // selectSkillRequest acima sem logica nova).
  const [editSkillRequest, setEditSkillRequest] = useState(null);

  // 2. Estados para controlar o pop-up de novidades
  //    Quando receber a rota do backend, você pode definir este estado dinamicamente.
  const [showNovidadesPopup, setShowNovidadesPopup] = useState(false);

  // front_planning_tools: estado do painel "Atividade" mora aqui (não dentro do
  // UnifiedChat) porque, visualmente, ele precisa ser uma coluna real do layout
  // (irmã de Historico/UnifiedChat dentro de .corpo-margem), com a mesma altura fixa
  // e o mesmo espaçamento simétrico que Historico já tem do lado esquerdo.
  const [activitySteps, setActivitySteps] = useState([]);
  const [activityPanelOpen, setActivityPanelOpen] = useState(false);
  // null = painel "ao vivo" (execução em andamento, mostra activitySteps). Um valor aqui é
  // o clientId/_id de uma mensagem já concluída - painel fica "preso" à timeline gravada
  // nela (msg.activity_timeline), pra cada pill reabrir a atividade da SUA própria skill em
  // vez de sempre mostrar a execução mais recente.
  const [activityPanelMessageId, setActivityPanelMessageId] = useState(null);
  const activityPanelMessage = activityPanelMessageId
    ? chatHistory.find(m => idDaMensagem(m) === activityPanelMessageId)
    : null;
  // Enquanto a mensagem presa ainda está em andamento (sem activity_timeline gravado - só
  // acontece na etapa "Concluído"), cai pro estado "ao vivo" (activitySteps) - só existe uma
  // execução em andamento por vez, então é sempre a dela mesma.
  const activityPanelSteps = activityPanelMessage?.activity_timeline || activitySteps;
  // Tarefa 9 (FR-019): total congelado da execução - a timeline gravada não tem
  // timestamp pra recalcular o tempo total, ele vem do mesmo valor que o pill mostra.
  const activityPanelTotalDurationMs = activityPanelMessage?.activity_summary?.duration_ms;
  // Mesmo instante que o indicador inline da mensagem usa - numa execução
  // reidratada o startedAt das linhas da timeline não diz quando a execução
  // começou, e os dois cronômetros ficavam marcando valores diferentes.
  const activityPanelStartedAt = activityPanelMessage?.activity_started_at;
  // Abaixo de 1024px não há espaço pro painel "Atividade" como coluna própria do layout -
  // o indicador inline/pill continuam existindo (ajustado em UnifiedChat.js/Message), só o
  // painel em si some. Se a janela encolher com o painel já aberto, ele fecha sozinho (efeito
  // abaixo) em vez de continuar "aberto" num estado que não tem mais onde aparecer.
  const hideActivityPanel = useMediaQuery('(max-width: 1023px)');
  const hasActivityPanel = activityPanelOpen && activityPanelSteps.length > 0 && !hideActivityPanel;

  useEffect(() => {
    if (hideActivityPanel) {
      setActivityPanelOpen(false);
    }
  }, [hideActivityPanel]);

  // Tarefa 2 (specs/front_planning_tools_ajustes_finais/plan.md, US2): fecha o painel da
  // conversa anterior assim que a troca de chat É INICIADA (loading vira true em
  // Historico/index.js::fetchSessionHistory), não só quando o conteúdo do novo chat termina
  // de carregar. Antes disso, o único reset ficava no efeito de UnifiedChat.js disparado por
  // `sessionId`, que só muda DEPOIS que o histórico já chegou - o painel antigo ficava
  // visível durante toda a janela do spinner.
  useEffect(() => {
    if (loading) {
      setActivityPanelOpen(false);
      setActivityPanelMessageId(null);
    }
  }, [loading]);


  const isLinksAvailable = assistant === 'References Assistant';
  const [links, setLinks] = useState([]);

  const isAddAvaliable = assistant === 'Sesan Assist';
  const [arquivo] = useState([]);

  const toggleExpand = (componentName) => {
    if (componentName === 'links' && !isLinksAvailable) {
      return;
    }
    if (componentName === 'addarquivo' && !isAddAvaliable) {
      return;
    }
    setExpandedComponent(prev => (prev === componentName ? null : componentName));
  };

  const { newSessionId } = useContext(AuthContext);

  const createNewChat = () => {
    try {
      const generatedSessionId = newSessionId();
      const newSession = { label: tChat('new_chat'), session_id: generatedSessionId };
      setSummaryInfo({ label: tChat('new_chat'), status: false, session_id: generatedSessionId });

      const history = [
        { role: "system", content: "" },
        { role: "assistant", content: tChat('newSessionGreeting') }
      ];

      setSessions([newSession, ...sessions]);
      setSelectedSession(generatedSessionId);
      setChatHistory(history);
      setLinks([]);
      setMessageSent(false);
      setActivitySteps([]);
      setActivityPanelOpen(false);
      setActivityPanelMessageId(null);


    } catch (error) {
      console.error('Erro ao criar nova sessão:', error);
    }
  };

  return (

    <div className='corpo-chat'>

      {/* Renderização condicional do pop-up */}
      {showNovidadesPopup && <NovidadesPopup onClose={() => setShowNovidadesPopup(false)} />}


      <div className='corpo-margem'>

        <ErrorBoundary resetKeys={[sessionId]} errorContext={{ sessionId, assistantId, email: user }}>
          <Historico
            setChatHistory={setChatHistory}
            classeCSS="historico-chat"
            newButtonName={tChat("new_chat")}
            isReportMode={isReportMode}
            setLoading={setLoading}
            sessions={sessions}
            setSessions={setSessions}
            selectedSession={selectedSession}
            setSelectedSession={setSelectedSession}
            sessionId={sessionId}
            setSessionId={setSessionId}
            user={user}
            assistant={assistant}
            setLinks={setLinks}
            assistantId={assistantId}
            createNewChat={createNewChat}
            summaryInfo={summaryInfo}
            setSummaryInfo={setSummaryInfo}
            messages={chatHistory}
            onCreateWithIris={() => setCreateSkillSignal((signal) => signal + 1)}
            onSelectSkill={(skill) => setSelectSkillRequest((prev) => ({ skill, seq: (prev?.seq || 0) + 1 }))}
            onEditSkillInChat={(skill) => setEditSkillRequest((prev) => ({ skill, seq: (prev?.seq || 0) + 1 }))}
          />
        </ErrorBoundary>

        <ErrorBoundary resetKeys={[sessionId]} errorContext={{ sessionId, assistantId, email: user }}>
          <UnifiedChat
            chatHistory={chatHistory}
            setChatHistory={setChatHistory}
            classeCSS={assistant === 'References Assistant' ? 'chatbox chatbox-expanded' : 'chatbox'}
            loading={loading}
            sessionId={sessionId}
            totalCost={totalCost}
            setTotalCost={setTotalCost}
            user={user}
            setLinks={setLinks}
            assistant={assistant}
            assistantId={assistantId}
            createNewChat={createNewChat}
            summaryInfo={summaryInfo}
            updateSummary={(updated) =>
              setSummaryInfo(prev => ({ ...prev, ...updated }))
            }
            setSessions={setSessions}
            selectedModel={selectedModel}
            setSelectedModel={setSelectedModel}
            messageSent={messageSent}
            setMessageSent={setMessageSent}
            setShowNovidadesPopup={setShowNovidadesPopup} // Passa a função para o ChatBox
            createSkillSignal={createSkillSignal}
            selectSkillRequest={selectSkillRequest}
            editSkillRequest={editSkillRequest}
            activitySteps={activitySteps}
            setActivitySteps={setActivitySteps}
            activityPanelOpen={activityPanelOpen}
            setActivityPanelOpen={setActivityPanelOpen}
            activityPanelMessageId={activityPanelMessageId}
            setActivityPanelMessageId={setActivityPanelMessageId}
            hideActivityPanel={hideActivityPanel}
          />
        </ErrorBoundary>

        {hasActivityPanel && (
          <ActivityPanel
            steps={activityPanelSteps}
            totalDurationMs={activityPanelTotalDurationMs}
            executionStartedAt={activityPanelStartedAt}
            onClose={() => setActivityPanelOpen(false)}
          />
        )}

        {(isAddAvaliable || isLinksAvailable) && (<div className='involucro-right' style={{ display: assistant === 'References Assistant' ? 'none' : 'flex' }}>

          <AddArquivo
            classeCSS={`addarquivo ${expandedComponent === 'addarquivo' ? 'expanded' : ''} ${!isAddAvaliable ? 'blocked' : ''}`}
            toggleExpand={() => toggleExpand('addarquivo')}
            arquivo={arquivo}
            isExpanded={expandedComponent === 'addarquivo'}
          />
          <div style={{ display: 'none' }}>
            <Links
              classeCSS={`links ${expandedComponent === 'links' ? 'expanded' : ''} ${!isLinksAvailable ? 'blocked' : ''}`}
              toggleExpand={() => toggleExpand('links')}
              links={links}
              isExpanded={expandedComponent === 'links'}
            />
          </div>

        </div>)}

      </div>

    </div>
  );
}

export default Chat;
